import { UnauthenticatedStreamQueryQuery } from '@/__generated__/graphql';
import { GetPageMetaArgs } from '@/routes-utils/get-page-meta';
import {
  getPageScreenshotUrl,
  getPageScreenshotVersion,
} from '@/routes-utils/page-screenshot-url';
import { streamOgImages } from './stream-og-images';

export const getStreamPageMeta = (
  stream: NonNullable<UnauthenticatedStreamQueryQuery['stream']>,
): GetPageMetaArgs => {
  const url = `https://synoptic.com/p/streams/${stream.id}`;
  const staticOg = streamOgImages[stream.id as keyof typeof streamOgImages];

  if (staticOg) {
    return {
      title: stream.name,
      previewDescription: stream.description ?? stream.name,
      twitterCreator: stream.author.xComHandle,
      twitterCard: 'summary_large_image',
      previewImage: staticOg,
      previewImageW: 1200,
      previewImageH: 630,
      url,
    };
  }

  const previewImage = getPageScreenshotUrl({
    type: 'stream',
    id: stream.id,
    version: getPageScreenshotVersion(stream),
  });

  return {
    title: stream.name,
    previewDescription: stream.description ?? stream.name,
    twitterCreator: stream.author.xComHandle,
    twitterCard: 'summary_large_image',
    previewImage,
    previewImageW: 600,
    previewImageH: 315,
    url,
  };
};
